import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import BannerFinish from '../assets/images/banner-finish-2.png';
import { Tools } from '../utils/tools';
import User from "../models/user";
import Global from "../models/global";

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class FinishPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            platform: Tools.platformDevice()
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        Global.isLogin = false;
        _root.props.process(User);
        _root.props.general(Global);
        window.location.reload();
    }

    render() {
        const {
            platform
        } = this.state;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        {
                            (platform === 'web') &&
                            <div className="col-sm-12 col-md-5" style={{ backgroundImage: 'url(' + BannerFinish + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}></div>
                        }
                        <div className="col-sm-12 col-md-7 right-side-main">
                            <div className="row justify-content-md-center">
                                <div className="col-sm-12 col-md-9 pb-4">
                                    <h1 className="text-bold">¡Muchas Gracias!<br />Terminaste tu Inscripción.</h1>
                                </div>
                                <div className="col-sm-12 col-md-9 pb-2">
                                    <p className="text-bold" style={{ fontSize: '20px', display: 'block', textAlign: 'justify' }}>Ahora el Ejecutivo(a) que te atendió validará los documentos e información enviada y se pondrá en contacto contigo para continuar el proceso de admisión.</p>
                                </div>
                                <div className="col-sm-12 col-md-9 pb-4">
                                    <p className="text-bold" style={{ fontSize: '20px', display: 'block', textAlign: 'justify' }}>Gracias por elegirnos para alcanzar tus objetivos profesionales y personales; y ayudarnos a transformar el país.</p>
                                </div>
                                <div className="col-sm-12 col-md-9 text-center">
                                    <button onClick={this.onClickNext} className="btn btn-primary btn-style-1 w-50">Finalizar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishPage);